module.exports = __webpack_public_path__ + "media/andre1.2852556f.mp3";